import * as types from './types';
import { execApi } from '../api/apiActions';
import PublicApi from '../../apis/public';


export const fetchRedirectNeeded = () => {
    return dispatch => {
        dispatch(execApi({
            type: types.FETCH_REDIRECT_NEEDED,
            api: PublicApi.fetchRedirectNeeded,
            successCallback: response => {
                if (response.url) {
                    window.location.href = response.url;
                }
            },
            useErrorDialog: false,
        }));
    };
};

export const getPracticeDetails = () => {
  return dispatch => {
    dispatch(execApi({
        type: types.GET_PRACTICE_DETAILS,
        api: PublicApi.getPracticeDetails,
        successCallback: response => {
          dispatch({
            type: types.GET_PRACTICE_DETAILS,
            payload: response.practice,
          });
        },
        // Our 'success: false' response object. Also called on catch of an exception.
        useErrorDialog: true,
      })
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/public/publicActions.js